import type { FaireProductEntity } from "../../entity_types/product";

export const p_yz5vsm6pbu: FaireProductEntity = {
  token: "p_yz5vsm6pbu",
  type: "product",
  name: "Zircon Inlaid Chain Fringe 18K Golden SS Stud Earrings - FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl: "https://cdn.faire.com/fastly/5af4ebc29f29a8e379dfb7508472d6d873ab83fb5eea643ae4d0e152ee677374.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e8ce86034d9cb0800d0f97c1e953091e7c6f74c0bf8ea6cf3f4a5c256c7fae12.jpeg",
    "https://cdn.faire.com/fastly/e1a9b7a3e5ba27e740601daacc2a15217b6c916dde5cca8d9baa3aa3e8c69ec9.jpeg",
    "https://cdn.faire.com/fastly/e1f4ef86cd76bc1703ec549d349618031b0cd007413e70914fbf3ddec013bfb9.jpeg"
  ],
  priceDollars: 11.04,
  description: "\nType: Earrings\nMaterial : Stainless steel ，Zircon，18K gold plated\nSize :10mm*46mm\nProcess: Vacuum electroplating and manual polishing,Non tarnish\nSurface : High Polish\n★Made of high quality stainless steel,Lead-free,Harmless to Human Body.\n★Perfect jewelry gifts ",
  tags: [],
  msrpDollars: 27.6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:00:12.426Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
